var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.321 3.24283L172.879 203.576C155.235 221.218 152.374 247.124 166.442 261.269C180.509 275.334 177.648 301.319 160.004 318.961L-82.8782 561.888",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.984 7.21613L202.683 411.38C185.039 429.021 156.269 429.021 138.625 411.38L91.4153 364.177C73.7713 346.535 45.0006 346.535 27.3567 364.177L-112.682 504.275",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.021 -2.31976L394.223 113.383C376.579 131.024 376.579 159.791 394.223 177.432L446.201 229.403C463.845 247.044 463.845 275.811 446.201 293.452L-68.5723 808.232",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-70.9566 691.417L43.2521 577.225C60.896 559.584 89.6667 559.584 107.311 577.225L161.673 631.58C179.317 649.221 208.088 649.221 225.732 631.58L650.457 206.914C668.101 189.272 696.872 189.272 714.516 206.914L730.252 222.648C747.896 240.29 776.667 240.29 794.311 222.648L1054.84 -37.6821",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.348 -5.49841L584.571 174.174C566.927 191.815 566.927 220.582 584.571 238.223L617.872 271.52C635.516 289.161 635.516 317.928 617.872 335.569L176.058 777.32C158.414 794.961 158.414 823.728 176.058 841.37L248.144 913.445",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.91 -6.29309L622.72 566.735C605.076 584.377 576.305 584.377 558.661 566.735L143.473 151.685C125.829 134.044 97.0581 134.044 79.4142 151.685L-87.6468 318.722",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55.0612 894.85L107.946 731.786C125.59 714.145 154.361 714.145 172.005 731.786L222.791 782.565C240.435 800.206 269.206 800.206 286.85 782.565L665.479 403.989C683.123 386.348 711.893 386.348 729.537 403.989L800.59 475.032C818.234 492.673 847.005 492.673 864.648 475.032L1370.36 -30.5302",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500.31 -6.29309L556.118 937.762",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.661 911.538L497.067 736.157C514.711 718.515 543.481 718.515 561.125 736.157L566.212 741.243C583.856 758.884 612.626 758.884 630.27 741.243L754.891 616.561C772.535 598.919 801.305 598.919 818.949 616.561L867.748 665.273C885.392 682.915 914.163 682.915 931.807 665.273L1552.68 44.4857",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.568 906.77L1130.5 628.878C1148.14 611.236 1148.14 582.47 1130.5 564.828L864.331 298.697C846.687 281.056 846.687 252.289 864.331 234.648L1126.76 -27.7489",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.88 -12.6504L1242.64 188.478C1225 206.119 1225 234.886 1242.64 252.527L1524.55 534.393",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.82 186.809L1264.9 435.617C1247.25 453.258 1247.25 482.025 1264.9 499.666L1307.26 542.101C1324.9 559.742 1324.9 588.509 1307.26 606.15L1097.99 815.464C1080.35 833.105 1051.58 833.105 1033.93 815.464L981.559 763.096C963.915 745.454 935.145 745.454 917.501 763.096L753.221 927.352",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.54 905.975L1527.73 478.846",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.79 893.261L1516.76 681.325C1534.4 663.684 1534.4 634.917 1516.76 617.276L1400.01 500.54C1382.36 482.899 1382.36 454.132 1400.01 436.491L1524.94 311.57",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.509 -17.4183L-90.4285 174.492",
    stroke: "#0076F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.372 474.873C279.639 474.873 283.909 470.604 283.909 465.337C283.909 460.07 279.639 455.801 274.372 455.801C269.104 455.801 264.834 460.07 264.834 465.337C264.834 470.604 269.104 474.873 274.372 474.873Z",
    fill: "#0076F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.69 796.71C1416.96 796.71 1421.23 792.44 1421.23 787.174C1421.23 781.907 1416.96 777.638 1411.69 777.638C1406.42 777.638 1402.15 781.907 1402.15 787.174C1402.15 792.44 1406.42 796.71 1411.69 796.71Z",
    fill: "#0076F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3245 811.014C43.5918 811.014 47.8618 806.744 47.8618 801.478C47.8618 796.211 43.5918 791.942 38.3245 791.942C33.0572 791.942 28.7872 796.211 28.7872 801.478C28.7872 806.744 33.0572 811.014 38.3245 811.014Z",
    fill: "#0076F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.65 523.347C510.917 523.347 515.187 519.078 515.187 513.811C515.187 508.545 510.917 504.275 505.65 504.275C500.383 504.275 496.113 508.545 496.113 513.811C496.113 519.078 500.383 523.347 505.65 523.347Z",
    fill: "#0076F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.22 500.302C1062.49 500.302 1066.76 496.033 1066.76 490.766C1066.76 485.5 1062.49 481.23 1057.22 481.23C1051.95 481.23 1047.68 485.5 1047.68 490.766C1047.68 496.033 1051.95 500.302 1057.22 500.302Z",
    fill: "#0076F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.23 172.902C1182.5 172.902 1186.77 168.633 1186.77 163.367C1186.77 158.1 1182.5 153.831 1177.23 153.831C1171.96 153.831 1167.69 158.1 1167.69 163.367C1167.69 168.633 1171.96 172.902 1177.23 172.902Z",
    fill: "#0076F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.239 223.761C725.506 223.761 729.776 219.491 729.776 214.225C729.776 208.958 725.506 204.689 720.239 204.689C714.971 204.689 710.701 208.958 710.701 214.225C710.701 219.491 714.971 223.761 720.239 223.761Z",
    fill: "#0076F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.488 271.44C170.755 271.44 175.025 267.171 175.025 261.904C175.025 256.638 170.755 252.368 165.488 252.368C160.221 252.368 155.951 256.638 155.951 261.904C155.951 267.171 160.221 271.44 165.488 271.44Z",
    fill: "#0076F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.161 104.562C524.429 104.562 528.699 100.292 528.699 95.0259C528.699 89.7594 524.429 85.49 519.161 85.49C513.894 85.49 509.624 89.7594 509.624 95.0259C509.624 100.292 513.894 104.562 519.161 104.562Z",
    fill: "#0076F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.529 830.88C863.796 830.88 868.066 826.611 868.066 821.344C868.066 816.078 863.796 811.808 858.529 811.808C853.261 811.808 848.991 816.078 848.991 821.344C848.991 826.611 853.261 830.88 858.529 830.88Z",
    fill: "#0076F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -113,
    y: -38,
    width: 1666,
    height: 976,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.0242f9dba375296467c977522e7acfbb.svg";
export { ForwardRef as ReactComponent };